export default __webpack_public_path__ + "static/media/table_document_front.fd8cf679.png";